import React from "react";
var __jsx = React.createElement;
var FlowStepTitle = function FlowStepTitle(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h3", {
    className: "text-gray-text text-base font-bold"
  }, children));
};
export default FlowStepTitle;